import Axios from 'axios'
import sha1 from 'sha1'
// 测试环境 https://testapi.dnaer.net
// 开发环境 https://devapi.dnaer.net
Axios.defaults.baseURL = Object.is(process.env.NODE_ENV, 'development') ? 'https://api.dnaerapp.com' : 'https://api.dnaerapp.com'
Axios.defaults.headers.post['Content-Type'] = 'application/json'
export default {
  sha1 (data) {
    return sha1(data)
  },
  data () {
    return {
      public: {
        appId: '1003604205986484225',
        version: '1.0.0',
        platform: 'mobile',
        token: ''
      },
      // imgHost: 'http://cdn.dnaerapp.com/test/static/img/'
      imgHost: 'https://www.dnaerapp.com/static/img/'

    }
  },
  mounted () {
    // merge object
    this.public = this.merge(this.public, {timestamp: Math.round(new Date().getTime())})
  },
  methods: {
    axios (http, config = this.public, methods) {
      config = this.merge(this.public, config)
      if (Object.is(methods, 'get')) {
        return new Promise((resolve, reject) => {
          Axios.get(http,{params: config}).then(res => {
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        })
      }
      return new Promise((resolve, reject) => {
        Axios.post(http, config).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    merge (json, json2) {
      return Object.assign({}, json, json2)
    }
  }
}
// interceptors
Axios.interceptors.request.use((config) => {
  // before request
  return config
}, (error) => {
  console.log(error)
})
Axios.interceptors.response.use((response) => {
  // response
  return response
}, (error) => {
  console.log(error)
})



// WEBPACK FOOTER //
// ./src/mixins/index.js